import { memo, useMemo } from 'react'
import { DonorAvatar } from '../../donorAvatar/DonorAvatar'
import { DEFAULT_AVATAR, type AvatarConfig } from '../../donorAvatar/avatar-catalog'
import { avatarWithCustomBases } from '../../donorAvatar/avatar-custom'
import { throwPose } from './frisbee-throw'

export const FrisbeeThrower = memo(function FrisbeeThrower({
  avatar,
  at,
}: {
  avatar?: AvatarConfig | null
  at: number
}) {
  const appearance = useMemo(() => {
    const base = avatar ?? DEFAULT_AVATAR
    // Keep the profile's character and custom pieces, without its portrait backdrop.
    return {
      ...base,
      custom: base.custom?.filter((piece) => piece.category !== 'background'),
    }
  }, [avatar])
  const pose = throwPose(at, avatarWithCustomBases(appearance))
  return (
    <g transform={`translate(${pose.x} 140)`} data-frisbee-thrower="account-avatar">
      <ellipse cx="41" cy="129" rx="26" ry="4" fill="#435f50" opacity=".18" />
      <path
        d="M33 91 30 120m20-29 5 29"
        stroke="#344858"
        strokeWidth="9"
        strokeLinecap="round"
      />
      <path
        d="M25 123h10m16 0h11"
        stroke="#fff5db"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <g transform="scale(.34)">
        <DonorAvatar
          config={appearance}
          transparent
          throwAngle={pose.angle}
          label="Seu avatar lançando o frisbee"
        />
      </g>
    </g>
  )
})
